import React from 'react';

import {
	NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO,
	resolveNativeEmbedInitialLayout,
	type NativeEmbedInitialLayout,
} from '@atlaskit/native-embeds-common/initial-layout';

export { resolveNativeEmbedInitialLayout, type NativeEmbedInitialLayout };

export type NativeEmbedInitialPlaceholderFrameProps = Pick<
	NativeEmbedInitialLayout,
	'effectiveHeight' | 'effectiveWidth' | 'lockAspectRatio'
>;

export const NativeEmbedInitialPlaceholderFrame = ({
	effectiveHeight,
	effectiveWidth,
	lockAspectRatio,
}: NativeEmbedInitialPlaceholderFrameProps): React.JSX.Element => {
	const placeholderStyle = {
		width: effectiveWidth ? `${effectiveWidth}px` : '100%',
		height: lockAspectRatio ? 'auto' : `${effectiveHeight}px`,
		aspectRatio: lockAspectRatio
			? effectiveWidth && effectiveHeight
				? `${effectiveWidth} / ${effectiveHeight}`
				: NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO
			: undefined,
	};

	return (
		<div
			data-testid="native-embed-initial-placeholder"
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- width/height/aspectRatio are dynamic ADF + manifest-derived layout values
			style={placeholderStyle}
		/>
	);
};

export const NativeEmbedInitialPlaceholder = ({
	alignment,
	effectiveHeight,
	effectiveWidth,
	hasEmbedBorder,
	lockAspectRatio,
}: NativeEmbedInitialLayout): React.JSX.Element => (
	<div
		data-native-embed-alignment={alignment}
		data-native-embed-width={effectiveWidth}
		data-native-embed-show-border={hasEmbedBorder ? 'true' : 'false'}
	>
		<NativeEmbedInitialPlaceholderFrame
			effectiveHeight={effectiveHeight}
			effectiveWidth={effectiveWidth}
			lockAspectRatio={lockAspectRatio}
		/>
	</div>
);
